import type { UsageDay } from "../api/types";
import { calendarCells } from "./calendar";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

/** A month of daily peaks as a calendar grid: amber days are the ones that
 *  went over the allowance, and the tooltip names who was on at the peak. */
export function PeakCalendar({
  month,
  days,
  included,
}: {
  month: string;
  days: UsageDay[];
  included: number | null;
}): JSX.Element {
  const cells = calendarCells(month, days, included);
  const lead = cells[0]?.weekday ?? 0;
  return (
    <section style={{ marginBottom: 24 }}>
      <h2 style={{ fontSize: 18, margin: "0 0 8px" }}>Daily peaks</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(7, minmax(40px, 1fr))",
          gap: 4,
          maxWidth: 560,
        }}
      >
        {WEEKDAYS.map((w) => (
          <div key={w} style={{ fontSize: 12, color: "#666", textAlign: "center" }}>
            {w}
          </div>
        ))}
        {Array.from({ length: lead }, (_, i) => (
          <div key={`lead-${i}`} />
        ))}
        {cells.map((c) => (
          <div
            key={c.day}
            data-over={c.over ? "true" : "false"}
            title={
              c.peakPeople === null
                ? c.day
                : `${c.day}: peak ${c.peakPeople} people, ${c.peakDevices} devices${
                    c.peakNames.length > 0 ? ` — ${c.peakNames.join(", ")}` : ""
                  }`
            }
            style={{
              padding: 6,
              borderRadius: 4,
              textAlign: "center",
              minHeight: 40,
              background: c.over ? "#fff3cd" : c.peakPeople === null ? "#f3f4f6" : "#e8f5e9",
              color: c.over ? "#5c4500" : "#222",
            }}
          >
            <div style={{ fontSize: 11, color: "#666" }}>{c.dayOfMonth}</div>
            <div style={{ fontWeight: 600 }}>{c.peakPeople ?? ""}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
